import { TDecorationType } from 'shared/types/api-models/offer-card/v1/get-offer-data';

export const decorationTypeHelper = (type: TDecorationType | null): string | null => {
  if (!type) {
    return null;
  }

  const name = {
    without: 'Без отделки',
    rough: 'Черновая',
    preFine: 'Предчистовая',
    fine: 'Чистовая',
    fineWithFurniture: 'Чистовая с мебелью',
    turnkey: 'Под ключ',
  };

  return name[type] || null;
};
